const liveSessionCodecAdapter = {
    resolveMediumCodecs: (codecs) => {
        return codecs.filter(codec => codec.mimeType.startsWith('video/VP9'));
    },
    resolveSlowCodecs: (codecs) => {
        return codecs.filter(codec => codec.mimeType.startsWith('video/VP8'));
    },
    resolveFastCodecs: (codecs) => {
        return codecs.filter(codec => codec.mimeType.startsWith('video/AV1'));
    },
    resolveCodecs: (transceiver, RTCRtpSender, navigator) => {
        if (!RTCRtpSender.getCapabilities || !transceiver.setCodecPreferences || typeof navigator.hardwareConcurrency === 'undefined') {
            return null;
        }
        const { codecs } = RTCRtpSender.getCapabilities('video');
        let priorityCodecs;
        if (navigator.hardwareConcurrency >= 8) {
            priorityCodecs = liveSessionCodecAdapter.resolveFastCodecs(codecs);
        } else if (navigator.hardwareConcurrency >= 4) {
            priorityCodecs = liveSessionCodecAdapter.resolveMediumCodecs(codecs);
        } else {
            priorityCodecs = liveSessionCodecAdapter.resolveSlowCodecs(codecs);
        }
        if (priorityCodecs.length) {
            // putting our preferred codec to the top of the list.
            const newOrder = [
                ...priorityCodecs,
                ...(codecs.filter(codec => !priorityCodecs.includes(codec))),
            ];
            return newOrder;
        }
        return null;
    },

    /**
     * Adapts video codec priority based on TT's capabilities. If not possible, then fallbacks to default.
     * @param rtcPeerConnection
     */
    adaptVideoCodec: (rtcPeerConnection) => {
        const transceivers = rtcPeerConnection.getTransceivers();
        if (!transceivers.length) {
            return;
        }
        const transceiver = transceivers[0];
        const codecs = liveSessionCodecAdapter.resolveCodecs(transceiver, window.RTCRtpSender, window.navigator);
        if (codecs) {
            transceiver.setCodecPreferences(codecs);
        }
    },
};

export default liveSessionCodecAdapter;
